import React from 'react';

function EducationItem({ education }) {
  const { date, degree, school, description, courses } = education;
  
  return (
    <div className="experience-item">
      <div className="date">{date}</div>
      <div className="role-details">
        <h4>{degree}</h4>
        <p className="company">{school}</p>
        <p className="description">{description}</p>
        <ul className="cv-skills">
          {courses.map((course, i) => (
            <li key={i}>{course}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default EducationItem; 